import axios from "axios";
import { TTSSettings } from "../../tts/store/reducers";
import { auth } from "../../../firebaseConfig";
import { franc } from "franc";
import { UserSettings } from "../../settings/store/services";
import { backendApi } from "../../../common/apiService";

let language = "";

export function getTTS(docEls: any[], text: string, settings: UserSettings) {
	return new Promise<any>((resolve, reject) => {
		let langDetectText = text;
		if (langDetectText.length <= 50) {
			langDetectText = "";
			docEls.forEach((el) => {
				langDetectText = langDetectText.concat(el.text);
			});
		}

		let langTxt = document.getElementById("fileViewerTextDivContainer")?.textContent
			? document.getElementById("fileViewerTextDivContainer")?.textContent
			: document.getElementById("page-1")?.textContent;
		language = franc(langTxt ? langTxt.slice(0, 200) : langDetectText);
		const languageMappings: Record<string, string> = {
			ita: "it",
			spa: "es",
			eng: "en",
			fra: "fr",
			deu: "de",
			cat: "ca",
		};
		language = languageMappings[language] || language;
		// language = i18n.language

		console.log(language, settings);

		let ttsSettings = {
			prosody_rate: settings.speech_rate,
			voice_gender: settings.speech_gender,
		};
		auth.currentUser?.getIdToken().then((token) => {
			let config = {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			};
			let body = {
				language_code: language,
				voice_gender: settings.speech_gender,
				text: text,
				prosody_rate: settings.speech_rate,
			};
			backendApi
				.post(`/tts`, body, config)
				.then((response) => {
					console.log("[getTTS] response:", response);
					if (response.data.audio_url) {
						// Fetch the audio from the presigned URL and convert to base64
						return fetch(response.data.audio_url)
							.then((res) => res.blob())
							.then((blob) => {
								const audioBlob = new Blob([blob], { type: "audio/mpeg" });

								return new Promise<any>((innerResolve, innerReject) => {
									const reader = new FileReader();
									reader.onloadend = () => {
										console.log("AOLOO", reader.result);
										innerResolve({
											audio: reader.result, // Now in data:audio/mpeg;base64,... format
											speech_marks: response.data.speech_marks,
										});
									};
									reader.onerror = innerReject;
									reader.readAsDataURL(audioBlob);
								});
							});
					} else {
						return Promise.reject(response.data);
					}
				})
				.then((result) => {
					resolve(result);
				})
				.catch((error) => {
					console.log("[getTTS] error:", error);
					reject(error);
				});
			// axios
			// 	.post(`https://fujjvnytml.execute-api.eu-central-1.amazonaws.com/staging/text-to-speech/`, {
			// 		"Authorization": `Bearer ${token}`,
			// 		text: text,
			// 		language: language,
			// 		settings: ttsSettings,
			// 	})
			// 	.then((response) => {
			// 		console.log("[getTTS] response:", response.data.body);
			// 		if (response.data.body) {
			// 			resolve({
			// 				audio: `data:audio/mpeg;base64,${response.data.body.audio}`,
			// 				speech_marks: response.data.body.speech_marks,
			// 			});
			// 		}
			// 		reject(response.data);
			// 	})
			// 	.catch((error) => {
			// 		console.log("[getTTS] error:", error.response);
			// 		reject(error.response);
			// 	});
		});
	});
}
